module.exports = __webpack_public_path__ + "img/htit6.348713dd.png";